export default "__VITE_ASSET__D6NFUgb4__"